<template>
	<div class="n-shell">
		<aside class="n-side">
			<div class="n-brand">
				<span class="n-brand__mark">m</span>
				<span class="n-brand__name">michollo</span>
				<span class="n-brand__tag">nueva interfaz</span>
			</div>
			<nav class="n-nav">
				<template v-for="(item, i) in menu" :key="i">
					<div v-if="item.category" class="n-nav__cat">
						{{ lower(item.title) }}
					</div>
					<router-link v-else-if="item.url" :to="item.url" class="n-nav__item" active-class="is-active">
						<fa-icon v-if="item.icon" :icon="item.icon" class="n-nav__ic" />
						<span>{{ lower(item.title) }}</span>
						<span v-if="item.badge && badgeFor(item.badge)" class="n-nav__badge">{{ badgeFor(item.badge) }}</span>
					</router-link>
				</template>
			</nav>
		</aside>

		<div class="n-main">
			<header class="n-top">
				<div class="n-top__search">
					<fa-icon :icon="['fal', 'search']" />
					<input type="text" placeholder="buscar ofertas, usuarios, tags…">
				</div>
				<div class="n-top__right">
					<n-presence :max="5" />
					<div v-if="user" class="n-top__me">
						<span class="n-top__hi">hola, {{ user.username }}</span>
						<n-avatar :src="user.image_url" :name="user.username" size="md" />
					</div>
				</div>
			</header>

			<main class="n-content">
				<router-view />
			</main>
		</div>
	</div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import rawMenu from '@/config/_menu';
import NPresence from '@/components/next/NPresence';
import NAvatar from '@/components/next/NAvatar';
import '@/design/tokens.css';

const store = useStore();

const ROLE_RANK = {
	disabled: 0,
	banned: 1,
	unverified: 2,
	user: 3,
	mod: 4,
	partner: 5,
	editor: 6,
	admin: 7,
	superadmin: 8,
};

const user = computed(() => store.getters.user);

function badgeFor(name) { return store.getters[`flags/${name}`] || 0; }

const userRank = computed(() => ROLE_RANK[user.value && user.value.role] || 0);

const menu = computed(() => rawMenu.filter((item) => {
	const need = item.auth ? (ROLE_RANK[item.auth] || 0) : 0;
	return userRank.value >= need;
}));

function lower(s) { return (s || '').charAt(0).toLowerCase() + (s || '').slice(1); }

onMounted(() => {
	// announce presence to the realtime server (server replies with usersOnline)
	if (store.$socket && user.value) store.$socket.emit('connected', user.value);
});
</script>

<style scoped>
.n-shell {
	display: grid;
	grid-template-columns: 248px 1fr;
	min-height: 100vh;
	background: var(--n-bg);
}
.n-side { background: linear-gradient(180deg, var(--n-sidebar-from), var(--n-sidebar-to)); color: var(--n-sidebar-text); padding: 20px 14px; }
.n-brand { display: flex; align-items: center; gap: 10px; color: #fff; font-weight: 800; font-size: 18px; padding: 6px 10px 18px; }
.n-brand__mark { width: 30px; height: 30px; border-radius: 9px; background: linear-gradient(135deg, var(--n-primary), var(--n-purple)); display: flex; align-items: center; justify-content: center; }
.n-brand__tag { font-size: 10px; font-weight: 600; color: var(--n-sidebar-muted); background: rgba(255, 255, 255, 0.08); padding: 2px 7px; border-radius: var(--n-r-pill); }
.n-nav { display: flex; flex-direction: column; gap: 2px; }
.n-nav__cat { font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em; color: var(--n-sidebar-muted); margin: 16px 12px 6px; }
.n-nav__item { display: flex; align-items: center; gap: 11px; padding: 10px 12px; border-radius: 10px; font-size: var(--n-fs-md); color: var(--n-sidebar-text); text-decoration: none; }
.n-nav__item:hover { background: rgba(255, 255, 255, 0.06); }
.n-nav__item.is-active { background: rgba(255, 255, 255, 0.12); color: #fff; font-weight: 600; }
.n-nav__ic { width: 18px; text-align: center; }
.n-nav__badge { margin-left: auto; background: var(--n-danger); color: #fff; font-size: 11px; padding: 1px 7px; border-radius: var(--n-r-pill); }

.n-main { display: flex; flex-direction: column; }
.n-top { display: flex; align-items: center; gap: var(--n-s4); padding: 16px 26px; }
.n-top__search { display: flex; align-items: center; gap: var(--n-s2); background: #fff; border: 1px solid var(--n-border); border-radius: var(--n-r-control); padding: 9px 14px; color: var(--n-muted); width: 320px; }
.n-top__search input { border: 0; outline: 0; font-size: var(--n-fs-sm); width: 100%; color: var(--n-text); }
.n-top__right { margin-left: auto; display: flex; align-items: center; gap: var(--n-s5); }
.n-top__me { display: flex; align-items: center; gap: var(--n-s2); }
.n-top__hi { color: var(--n-muted); font-size: var(--n-fs-sm); }
.n-content { padding: 8px 26px 32px; }
</style>
